import React, { useEffect, useRef, useState } from 'react'
import styles from './display__control.jcss'
import { Preview } from './display__preview'
import { Remote } from './display__remote'
import { api } from '../../../core/api/ConnectionManager'
import translate from '../../../core/translate'
import { RootStateOrAny, useSelector } from 'react-redux'
import { cn } from 'ethcss'
import helpers from '../../../core/helpers'
import KeyboardEventHandler from 'react-keyboard-event-handler'
import EditText from '../../../blocks.simple/editText/editText'
import Button from '../../../blocks.simple/button/button'
import Icon from '../../../blocks.simple/icon/icon'
import { colors } from '../../../theme'
import Dropzone from 'react-dropzone'
import { createRequestHeaders } from '../../../core/helpers/user'
import { emitError } from 'features/appNotifications/AppNotifications.state'
import { useDispatch } from 'react-redux'
import { FileManager } from './fileManager/FileManager'
import { DeviceTerminal } from './deviceTerminal/DeviceTerminal'

export type Event = {
    type: string
    data: any
}

let dragStart = false

export const DisplayRemoteControl = ({ device, onClose }: any) => {
    const [fileManagerStatus, setFileManagerStatus] = useState<{ status: string; progress: number } | null>(null)
    const [terminalMode, setTerminalMode] = useState<boolean>(false)
    const [fileManagerMode, setFileManagerMode] = useState<boolean>(false)
    const [keyboardMode, setKeyboardMode] = useState<boolean>(false)
    const inputFileRef = useRef<any>(null)
    const dropzoneRef = useRef<any>(null)
    const app: any = useSelector<RootStateOrAny>((state) => state.app)
    const [peerConnection, setPeerConnection] = useState<RTCPeerConnection | null>(null)
    const [showMobRemote, setShowMobRemote] = useState<boolean>(false)
    const [fileModalOpened, setFileModalOpened] = useState(false)
    const [fileUrl, setFileUrl] = useState<string>('')
    const [filePath, setFilePath] = useState<string>('')
    const [progress, setProgress] = useState<number | null>(null)
    const [isOffline, setIsOffline] = useState<boolean>(false)
    const [isConnected, setIsConnected] = useState(false)
    const [downloadStep, setDownloadStep] = useState<string>('server')
    const [connection, setConnection] = useState<boolean>(true)
    const [files, setFiles] = useState<any>(null)
    const { data: user, mainUser, tokens }: any = useSelector<RootStateOrAny>((state) => state.user)
    const dispatch = useDispatch()
    const handleKeys = ['ctrl+c', 'ctrl+v', 'ctrl+a', 'ctrl+alt+delete', 'ctrl+shift', 'alt+shift', 'ctrl+s', 'all']

    const onOpenFilesClick = () => {
        if (inputFileRef.current) {
            inputFileRef.current.click()
        }
    }

    const onDrop = (filesList: any) => {
        setFileModalOpened(false)

        const formData = new FormData()

        if (!user || !mainUser || !tokens) return

        setDownloadStep('server')

        const headers = createRequestHeaders(user, mainUser, tokens)

        formData.append('digitalSignageId', device.id)
        formData.append('file', filesList[0])

        api.post('webRTCUploadFile', formData, headers)
            .on('progress', function (e) {
                const progress = e.percent ? Math.round(e.percent) : null

                setProgress(progress)
            })
            .catch((err) => {
                console.error(err)
                dispatch(emitError('fileIsDownloadingError'))
                setProgress(null)
            })
    }

    const getClipBoardValue = async () => {
        try {
            return await navigator.clipboard.readText()
        } catch (e) {
            console.log(e)
        }
    }
    const setClipBoardValue = async (text: string) => {
        try {
            return await navigator.clipboard.writeText(text)
        } catch (e) {
            console.log(e)
        }
    }

    const openFileModal = () => {
        setFileModalOpened(true)
    }

    const closeFileModal = () => {
        setFileModalOpened(false)
    }

    const sendFileUrl = () => {
        api.send('remoteControlSendFileUrl', {
            digitalSignageId: device.id,
            fileUrl,
        }).then(() => closeFileModal())
    }

    const cancelDownload = () => {
        api.send('remoteControlCancelFileDownload', {
            digitalSignageId: device.id,
        }).then(() => closeFileModal())
    }

    const sendEventToDS = (event: Event) => {
        if (!device) return

        if (event.type === 'click' && (!device.resolutionWidth || !device.resolutionHeight)) return

        console.log('send event to device')
        console.log(event)

        api.send('sendRemoteDeviceEvent', {
            digitalSignageId: device.id,
            ...event,
        })
    }

    const onKeyboardEvent = (key: string, e: KeyboardEvent) => {
        if (!keyboardMode) return

        if (key === 'ctrl+v') {
            getClipBoardValue().then((text) => {
                sendEventToDS({
                    type: 'clipboard',
                    data: {
                        text,
                    },
                })
            })

            return
        }

        if (handleKeys.includes(key)) {
            sendEventToDS({
                type: 'keyboardCombo',
                data: {
                    keyCombo: key,
                },
            })

            return
        }

        sendEventToDS({
            type: 'keyboard',
            data: {
                code: e.code,
                symbol: e.key,
            },
        })
    }

    const onReceiveProgress = (progress: number) => {
        if (progress < 100) {
            setProgress(progress)

            return
        }

        setProgress(null)
    }

    const renderStatusMessage = () => {
        return translate('remoteControlDeviceIsOffline')
    }

    const renderFileModal = () => {
        return (
            <div className={styles.modal}>
                <div className={cn(styles.modalInner, styles.fileModal)}>
                    <div className={styles.modalTitle}>{translate('fileSending')}</div>
                    <div className={styles.fileSelect}>
                        <input
                            type={'file'}
                            ref={inputFileRef}
                            style={{ display: 'none' }}
                            onChange={(e) => setFiles(e.target.files)}
                        />
                        <div className={styles.fileSelectLabel}>{translate('uploadLocalFile')}</div>
                        {/*<div className={styles.uploadButtonWrapper}>*/}
                        {/*    <Button*/}
                        {/*        onClick={onOpenFilesClick}*/}
                        {/*        mod={'fill'}*/}
                        {/*    >*/}
                        {/*        {translate('dashboard')}*/}
                        {/*    </Button>*/}
                        {/*    */}
                        {/*</div>*/}
                        {/*<div className={styles.or}>{translate('or')}</div>*/}
                        <Dropzone ref={dropzoneRef} onDrop={(acceptedFiles: any) => onDrop(acceptedFiles)}>
                            {({ getRootProps, getInputProps }) => {
                                const folderInputProps = getInputProps()
                                delete folderInputProps.accept
                                delete folderInputProps.multiple

                                return (
                                    <div
                                        {...getRootProps({
                                            onClick: (event) => event.stopPropagation(),
                                            onDragEnter: (any) => {
                                                dragStart = true
                                            },
                                            onDragLeave: () => {
                                                dragStart = false
                                            },
                                            className: cn(styles.dropzone),
                                        })}
                                    >
                                        <input {...getInputProps()} type={'file'} ref={inputFileRef} />
                                        <div className={styles.dropArea} onClick={onOpenFilesClick}>
                                            <div>{translate('clickOrDragFileHere')}</div>
                                            {dragStart && <div className={styles.dragInfo} />}
                                        </div>
                                    </div>
                                )
                            }}
                        </Dropzone>
                        {files && <div className={styles.fileName}>{files[0].name}</div>}
                    </div>
                    <EditText
                        placeholder={translate('enterFileLink')}
                        value={fileUrl}
                        mod="withBorder"
                        label={translate('fileLink')}
                        onChange={(value: string) => setFileUrl(value)}
                    />
                    <div className={styles.modalDesc}>{translate('onlyOneLink')}</div>
                    {filePath && (
                        <div className={styles.modalFilePath}>
                            {translate('fileWillBeSaveToDirectory')}: {filePath}
                        </div>
                    )}
                    <div className={styles.modalButtons}>
                        <Button mod={'withBorder'} className={styles.modalButton} onClick={closeFileModal}>
                            {translate('close')}
                        </Button>
                        <Button
                            mod="fill"
                            className={styles.modalButton}
                            onClick={() => {
                                if (files) {
                                    onDrop(files)

                                    return
                                }

                                sendFileUrl()
                            }}
                            disabled={!fileUrl && !files}
                        >
                            {translate('upload')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    const renderPlaceholderModal = () => {
        return (
            <div className={styles.modal}>
                <div className={cn(styles.modalInner, styles.placeholderModal)}>
                    <div className={styles.modalText}>{translate('waitOrCancel')}</div>
                    <div className={styles.modalButtons}>
                        <Button mod={'withBorder'} className={styles.modalButton} onClick={closeFileModal}>
                            {translate('close')}
                        </Button>
                        <Button
                            disabled={downloadStep !== 'device'}
                            mod="fill"
                            className={styles.modalButton}
                            onClick={cancelDownload}
                        >
                            {translate('cancelUpload')}
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    const reconnect = () => {
        console.log('stop device stream')

        api.send('stopRemoteDeviceStream', { digitalSignageId: device.id }).then(() => {
            setConnection(false)
            setPeerConnection(null)
        })
    }

    useEffect(() => {
        api.send('remoteControlEnableKeyboardCapture', {
            digitalSignageId: device.id,
            keyboardCapture: keyboardMode,
        })
    }, [keyboardMode, isConnected])

    useEffect(() => {
        if (!device) return

        return () => {
            console.log('stop device stream')

            api.send('stopRemoteDeviceStream', { digitalSignageId: device.id })
        }
    }, [])

    useEffect(() => {
        return () => {
            if (peerConnection) {
                peerConnection.close()
            }
        }
    }, [peerConnection])

    useEffect(() => {
        let timeout: any = null

        if (!connection) {
            timeout = setTimeout(() => {
                setConnection(true)
            }, 1000)
        }

        return () => clearTimeout(timeout)
    }, [connection])

    useEffect(() => {
        if (isConnected) {
            setIsOffline(false)
            return
        }
    }, [isConnected])

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver(
            'dsRemoteControlClipboardDataReceived',
            (data: any) => {
                if (data && data.text && data.digitalSignageId === device.id) {
                    setClipBoardValue(data.text)
                }
            },
            listenersId
        )
        api.addObserver(
            'dsRemoteControlDownloadProgress',
            (data: any) => {
                if (data && data.digitalSignageId === device.id) {
                    setDownloadStep('device')
                    onReceiveProgress(data.progress)
                }
            },
            listenersId
        )
        api.addObserver(
            'dsRemoteControlFilePathInfo',
            (data: any) => {
                if (data && data.digitalSignageId === device.id) {
                    setFilePath(data.path)
                }
            },
            listenersId
        )
        api.addObserver(
            'dsRemoteControlDeviceIsOffline',
            (data: any) => {
                if (data && data.digitalSignageId === device.id) {
                    setIsOffline(true)
                    setIsConnected(false)
                }
            },
            listenersId
        )
        api.addObserver(
            'dsRemoteControlReconnect',
            (data: any) => {
                if (data && data.digitalSignageId === device.id) {
                    reconnect()
                }
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    })

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver(
            'fileManagerDownloadProgress',
            (data: any) => {
                if (data && data.digitalSignageId === device.id) {
                    setFileManagerStatus({ status: data.status, progress: data.progress })
                }
            },
            listenersId
        )

        api.addObserver(
            'fileManagerFileLinkReady',
            (data: any) => {
                if (data && data.digitalSignageId === device.id) {
                    setFileManagerStatus(null)

                    const a = document.createElement('a')
                    a.href = data.fileUrl
                    a.click()
                }
            },
            listenersId
        )

        api.addObserver(
            'remoteControlError',
            (res: any) => {
                if (res && res.digitalSignageId === device.id) {
                    dispatch(emitError(res.error))
                }
            },
            listenersId
        )

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    }, [])

    return (
        device && (
            <>
                <div className={styles.wrapper}>
                    <div className={styles.caption}>
                        {translate('deviceManagement')}:<b> {device.name}</b>
                    </div>
                    <div className={styles.backButton} onPointerDown={onClose}>
                        <Icon type={'backArrow'} size={20} color={colors.white} />
                        <span>{translate('back')}</span>
                    </div>
                    <div className={styles.controlPanel}>
                        <div
                            className={styles.controlBtn}
                            onPointerDown={(e) => {
                                e.stopPropagation()
                                setTerminalMode(false)
                                setFileManagerMode(false)
                            }}
                        >
                            <Icon
                                type={'windowMode'}
                                size={22}
                                color={colors.white}
                                tooltip={{
                                    title: translate('hideWindows'),
                                }}
                            />
                        </div>
                        <div className={styles.controlBtn} onPointerDown={openFileModal}>
                            <Icon
                                type={'sendFile'}
                                size={20}
                                color={colors.white}
                                tooltip={{
                                    title: translate('sendFile'),
                                }}
                            />
                        </div>
                        <div
                            className={cn(styles.controlBtn, terminalMode ? styles.btnEnabled : '')}
                            onPointerDown={(e) => {
                                e.stopPropagation()
                                setTerminalMode(!terminalMode)
                                setKeyboardMode(false)
                            }}
                        >
                            <Icon
                                type={'terminal'}
                                size={20}
                                color={colors.white}
                                tooltip={{
                                    title: translate('openTerminal'),
                                }}
                            />
                        </div>
                        <div
                            className={cn(styles.controlBtn, fileManagerMode ? styles.btnEnabled : '')}
                            onPointerDown={(e) => {
                                e.stopPropagation()
                                setFileManagerMode(!fileManagerMode)
                                setKeyboardMode(false)
                            }}
                        >
                            <Icon
                                type={'fileItem'}
                                size={20}
                                color={colors.white}
                                tooltip={{
                                    title: translate('openFileManager'),
                                }}
                            />
                        </div>
                        <div
                            className={cn(styles.controlBtn, keyboardMode ? styles.btnEnabled : '')}
                            onPointerDown={(e) => {
                                e.stopPropagation()
                                setKeyboardMode(!keyboardMode)
                                setTerminalMode(false)
                                setFileManagerMode(false)
                            }}
                        >
                            <Icon
                                type={'keyboard'}
                                size={20}
                                color={colors.white}
                                tooltip={{
                                    title: translate('enableKeyboardCapture'),
                                }}
                            />
                        </div>
                    </div>
                    <div className={styles.inner}>
                        <div className={styles.leftBlock}>
                            <Preview
                                onEvent={sendEventToDS}
                                device={{
                                    ...device,
                                    resolutionWidth: device.resolutionWidth || 1920,
                                    resolutionHeight: device.resolutionHeight || 1080,
                                }}
                                peerConnection={peerConnection}
                                setPeerConnection={setPeerConnection}
                                setIsConnected={setIsConnected}
                                connection={connection}
                            />
                            <div className={styles.statusWrapper}>
                                {!isOffline && progress !== null && (
                                    <div className={styles.statusInner}>
                                        <div className={styles.status}>
                                            {/*<Icon type={'inProgressClock'} size={20} color={colors.warning} />*/}
                                            <div className={styles.downloadMessage}>
                                                {translate(
                                                    downloadStep === 'server'
                                                        ? 'fileIsDownloadingByServer'
                                                        : 'fileIsDownloading'
                                                )}
                                            </div>
                                        </div>
                                        <div className={styles.progress}>
                                            {translate('progress')}: {progress}%
                                        </div>
                                    </div>
                                )}
                                {isOffline && (
                                    <div className={styles.statusInner}>
                                        <div className={styles.status}>{`${translate('device')} ${translate(
                                            'offline'
                                        )}`}</div>
                                        <div className={styles.statusDescription}>{renderStatusMessage()}</div>
                                    </div>
                                )}
                            </div>
                        </div>
                        {helpers.isAvailableAction(device, {
                            key: 'digitalSignage',
                            action: 'update',
                        }) && (
                            <>
                                <div
                                    className={cn(
                                        styles.rightBlock,
                                        showMobRemote && app.isMobile ? styles.showMobRemote : ''
                                    )}
                                >
                                    <Remote onEvent={sendEventToDS} isMobile={app.isMobile} />
                                    {app.isMobile && showMobRemote && (
                                        <div className={styles.hideRemoteBtn} onClick={() => setShowMobRemote(false)}>
                                            <img src={'images/displays/hide-remote-icon.svg'} />
                                        </div>
                                    )}
                                </div>
                                {app.isMobile && !showMobRemote && (
                                    <div className={styles.showRemoteBtn} onClick={() => setShowMobRemote(true)}>
                                        <img src={'images/displays/remote-icon.svg'} />
                                    </div>
                                )}
                            </>
                        )}
                        {fileModalOpened ? (progress === null ? renderFileModal() : renderPlaceholderModal()) : null}
                        {fileManagerMode && (
                            <FileManager digitalSignageId={device.id} downloadStatus={fileManagerStatus} />
                        )}
                        {terminalMode && (
                            <DeviceTerminal
                                device={device}
                                onClose={() => {
                                    setTerminalMode(false)
                                }}
                            />
                        )}
                    </div>
                </div>
                <KeyboardEventHandler
                    handleKeys={handleKeys}
                    onKeyEvent={(key: string, e) => {
                        onKeyboardEvent(key, e)
                    }}
                />
            </>
        )
    )
}
